import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { ToastModule } from 'primeng/toast';
import { UploadingToastComponent } from './core/components/uploading-toast/uploading-toast.component';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter, Subject, takeUntil } from 'rxjs';
import { EventType, InteractionStatus } from '@azure/msal-browser';
import { AuthService } from './core/services/auth/auth.service';
import { environment } from '../environments/environment';
import { PrimeNG } from 'primeng/config';
import { GlobalLoaderComponent } from './features/global-loader/global-loader.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    ToastModule,
    ConfirmDialogModule,
    UploadingToastComponent,
    GlobalLoaderComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  readonly authService = inject(AuthService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly primeng = inject(PrimeNG);

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    this.authService.handleRedirect();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.authService.setActiveAccount();
        this.authService.getUserProfile();
        this.checkAndRenewToken();
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.isLoggedIn();
  }

  checkAndRenewToken() {
    const scopes = [environment.msalConfig.apiScope];
    this.authService.checkAndRenewToken(scopes);
  }

  loginRedirect() {
    this.authService.loginRedirect();
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
